export default __webpack_public_path__ + "static/media/img10.a93e4710.webp";